import { getActiveMemberIndex, getFamilyList } from '../helper';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setMemberCoverageSummary,
  setMemberAccumulatorSummary,
  setNetworkList,
} from 'src/redux/member/memberSlice';
import APIEndpoints from '../../../../../Member/api/APIEndpoints';
import {
  CoverageDetailedSummary,
  getNetworkByMasterId,
  getAccumByProduct,
  identifyDefaultNetwork,
  getIndplanMax,
  getExceptionTier,
  getBenefitYearProps,
} from '../../../../utils/Coverage';
import { axiosInstance } from '../../../../../api/axios';
import { insertSpaces } from '../../../../utils/strings';
import base64url from 'base64url';
import moment from 'moment';
import {
  findOutDefaultRangeBasedOnHistory,
  findEffectiveDateInPlanYear,
  makeDatesArrayAsPerNeed,
} from '../../../../utils/dates';

export const useCoverage = () => {
  //const [ activeMemberType, setActiveMemberType ] = useState()
  //const [ activeMemberOID, setActiveMemberOID ] = useState()
  const [activeMemberIndex, setActiveMemberIndex] = useState(0);
  const [memberAccumulatedData, setMemberAccumulatedData] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState();
  const [skeletonLoader, setSkeletonLoader] = useState(true);
  const [serverError, setServerError] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [defaultNetworkForAll, setDefaultNetworkForAll] = useState();
  const dispatch = useDispatch();
  const {
    memberSummaryStatus,
    employeeInfo,
    dependentsInfo,
    loggedInUserOID,
    loggedInMemberType,
  } = useSelector((state) => state.memberSummary);
  const [activeMember, setActiveMember] = useState(
    employeeInfo.Family ? 'Family' : 'Individual',
  );
  const { MemberStatePreserve, networkListWithMasterId } = useSelector(
    ({ memberSummary }) => memberSummary,
  );
  const { coverageSummary, accumulatorSummary } = MemberStatePreserve;
  const { Coverage_Network } = useSelector((state) => state.app.customNetwork);
  const {
    Display_Network_For_Coverage_Member,
    Value_Network_For_FindProvider_Member,
  } = useSelector((state) => state.app.appConfigs.Network_Setting);
  const Coverage_Year_Range =
    useSelector(
      (state) => state.app.appConfigs.Common_Setting.Coverage_Year_Range,
    ) || 5;

  const fetchCoveragAccumulator = useCallback(
    async (memberType, oid) => {
      //const currentDate = ( new Date() ).toISOString().split( 'T' )[ 0 ];
      const defaultNetworkArray = [];
      if (
        Object.keys(coverageSummary).length === 0 ||
        Object.keys(accumulatorSummary).length === 0 ||
        memberType === 'Dependent'
      ) {
        try {
          const currentDate = moment().format('YYYY-MM-DD');
          let defaultDateFilters = null;
          const responseHistoryAPI = await axiosInstance.get(
            APIEndpoints.getMemberExtCoverageSummaryResource() +
              memberType +
              '/oid/' +
              oid,
          );
          if (
            responseHistoryAPI &&
            responseHistoryAPI?.data.Response.EligibilityCoverage.length > 0
          ) {
            const memberHistoryData =
              responseHistoryAPI?.data.Response.EligibilityCoverage;
            const defaultSeleactedYear =
              findOutDefaultRangeBasedOnHistory(memberHistoryData);
            console.log('===============================');
            console.log(defaultSeleactedYear);

            if (
              defaultSeleactedYear &&
              defaultSeleactedYear.MemberCoverage.length > 0
            ) {
              const firstItemSelected = defaultSeleactedYear.MemberCoverage[0];
              const currentActiveCoverageType = firstItemSelected.Product;

              let memberYearData = null;

              const responseYearAPI = await axiosInstance.get(
                APIEndpoints.getPlanYearPeriod() +
                  '/EmployeeType/' +
                  memberType +
                  '/oid/' +
                  oid +
                  '/Product/' +
                  currentActiveCoverageType +
                  '/Year/' +
                  Coverage_Year_Range,
              );
              memberYearData = responseYearAPI?.data.Response.PlanYearPeriod;
              console.log('++++++++++++++++++++++');
              memberYearData = makeDatesArrayAsPerNeed(memberYearData);
              if (
                moment(currentDate).isSameOrAfter(
                  defaultSeleactedYear.EffectiveDate,
                  'year',
                )
              ) {
                defaultDateFilters = findEffectiveDateInPlanYear(
                  memberYearData,
                  currentDate,
                );
              }
              console.log(defaultDateFilters);
              if (
                defaultDateFilters === null ||
                defaultDateFilters === undefined
              ) {
                const tempYear = moment(
                  defaultSeleactedYear.EffectiveDate,
                ).year();
                defaultDateFilters = {
                  PlanYearDescription: `${tempYear}-01-01 - ${tempYear}-12-31`,
                  PlanYear: tempYear,
                  fromDate: `${tempYear}-01-01`,
                  toDate: `${tempYear}-12-31`,
                };
              }
            }
          } else {
            throw new Error('404 history not found');
          }

          const coverageSummaryResourceResponse = await axiosInstance.get(
            APIEndpoints.getMemberCoveragePlan() +
              memberType +
              '/oid/' +
              oid +
              '/planstartdate/' +
              defaultDateFilters.fromDate +
              '/planenddate/' +
              defaultDateFilters.toDate,
          );

          const CoverageSummaryData =
            coverageSummaryResourceResponse.data.Response.EligibilityCoverage;
          const effectiveDate = CoverageSummaryData[0].EffectiveDate;

          let networkCall = [];
          const memberExtCoveragedata =
            CoverageSummaryData[0].MemberCoverage.filter(
              (item) =>
                item?.Product === 'Medical' ||
                item?.Product === 'Dental' ||
                item?.Product === 'Prescription' ||
                item?.Product === 'Vision',
            );
          //Network code start here
          if (networkListWithMasterId && networkListWithMasterId.length > 0) {
            networkCall = memberExtCoveragedata.filter(
              (o1) =>
                !networkListWithMasterId.some(
                  (o2) => o1?.MasterId === o2.masterId,
                ),
            );
          } else {
            networkCall = memberExtCoveragedata;
          }
          let networkByMasterList = [];
          if (networkCall && networkCall.length > 0) {
            networkCall = networkCall.filter((f) => f?.MasterId > 0);
            const promises = networkCall.map(async (item) => {
              let networkItem;
              if (
                item?.MasterId > 0 &&
                (item?.Product === 'Medical' ||
                  item?.Product === 'Dental' ||
                  item?.Product === 'Prescription' ||
                  item?.Product === 'Vision')
              ) {
                networkItem = await axiosInstance.get(
                  APIEndpoints.getMemberCoverageNetwork() +
                    'MasterID/' +
                    item?.MasterId +
                    `/product/${item?.Product}/benefitplan/${btoa(
                      item?.BenefitPlan,
                    )}`,
                );
              }
              return networkItem;
            });

            try {
              const results = await Promise.all(
                promises.map((p) => p.catch((e) => e)),
              );
              const validResults = results.filter(
                (result) => !(result instanceof Error),
              );
              console.log(validResults);
              networkByMasterList = getNetworkByMasterId(validResults);
              dispatch(setNetworkList(networkByMasterList));
            } catch (error) {
              console.log('Network API fails');
            }
          }

          const accPromises = memberExtCoveragedata.map(async (item) => {
            let accItem;
            const firstItemSelected = item;

            if (item?.MasterId > 0) {
              const currentYear = new Date().getFullYear();

              const lastestNetworkList =
                networkByMasterList && networkByMasterList.length > 0
                  ? networkByMasterList
                  : networkListWithMasterId;
              let defaultNetwork = {
                selected: { label: 'Default', value: 0 },
              };
              if (Display_Network_For_Coverage_Member === true) {
                if (Value_Network_For_FindProvider_Member === 'tier') {
                  defaultNetwork = identifyDefaultNetwork(
                    firstItemSelected,
                    lastestNetworkList,
                    Coverage_Network,
                    true,
                  );
                } else {
                  defaultNetwork = identifyDefaultNetwork(
                    firstItemSelected,
                    lastestNetworkList,
                    Coverage_Network,
                  );
                }
                if (
                  defaultNetwork &&
                  defaultNetwork.networkProps.length === 0
                ) {
                  defaultNetwork = {
                    selected: { label: 'Default', value: 0 },
                  };
                }
              }
              defaultNetworkArray.push({
                defaultNetwork: defaultNetwork?.selected?.label,
                planProduct: firstItemSelected?.Product,
              });
              const indplanMax = getIndplanMax(firstItemSelected);
              //let exceptionTier = 'N';
              //if ( defaultNetwork.selected.value !== 0 ) {
              //exceptionTier = getExceptionTier( lastestNetworkList[ defaultNetwork.selected.NetID ] );
              //}
              const queryString = `/masterid/${
                firstItemSelected?.MasterId
              }/planYear/${currentYear}/networkid/${
                defaultNetwork.selected.value
              }/product/${firstItemSelected.Product}/benefitplan/${btoa(
                firstItemSelected.BenefitPlan,
              )}/effectivedate/${effectiveDate}/indplanmax/${indplanMax}/planyearstartdate/DED`;
              accItem = await axiosInstance.get(
                APIEndpoints.getMemberCoverageAccumsResource() +
                  memberType +
                  '/oid/' +
                  oid +
                  queryString,
              );
            }
            setDefaultNetworkForAll(defaultNetworkArray);
            return accItem;
          });

          let accumkByProduct = [];
          try {
            const accumResults = await Promise.all(
              accPromises.map((p) => p.catch((e) => e)),
            );
            const accumValidResults = accumResults.filter(
              (result) => !(result instanceof Error),
            );
            console.log(accumValidResults);
            accumkByProduct = getAccumByProduct(accumValidResults);
          } catch (error) {
            console.log('Network API fails');
          }

          //const accumulatorResponse = await axiosInstance.get( APIEndpoints.getMemberAccumulatorResource () + memberType + '/oid/' + oid );
          if (memberType === 'Employee') {
            //dispatch( setMemberCoverageSummary( coverageSummaryResourceResponse.data.Response.EligibilityCoverage ) );
            //dispatch( setMemberAccumulatorSummary( accumulatorResponse.data.Response ) );
          }

          const matchAccumDataLikeResponse = {
            BenefitAccumulators: [],
            PlanDetails: [],
          };
          accumkByProduct.map((f) => {
            matchAccumDataLikeResponse.BenefitAccumulators.push(
              f.data.BenefitAccumulators[0],
            );
            f.data.PlanDetails.map((i) => {
              matchAccumDataLikeResponse.PlanDetails.push(i);
              return;
            });
            return;
          });

          //const accumulatedDataResponse = CoverageDetailedSummary( coverageSummaryResourceResponse.data.Response.EligibilityCoverage[ 0 ].MemberCoverage, accumulatorResponse.data.Response );
          const accumulatedDataResponse = CoverageDetailedSummary(
            coverageSummaryResourceResponse.data.Response.EligibilityCoverage[0]
              .MemberCoverage,
            matchAccumDataLikeResponse,
          );

          const accumulatedData = [];
          accumulatedDataResponse.map((data) => {
            if (
              data?.Product === 'Medical' ||
              data?.Product === 'Dental' ||
              data?.Product === 'Prescription' ||
              data?.Product === 'Vision' ||
              data?.Product === 'ShortTermDisability' ||
              data?.Product === 'LongTermDisability'
            ) {
              //const network=defaultNetworkArray.find( ( network )=>network?.planProduct===data?.Product );
              accumulatedData.push(data);
            }
          });
          setMemberAccumulatedData(accumulatedData);
          console.log(accumulatedData);
          setServerError(false);
          setSkeletonLoader(false);
        } catch (error) {
          setIsAPIFailed(true);
          if (error.toString().includes('404')) {
            setIsNotFound(true);
          }
          setSkeletonLoader(false);
          setServerError(true);
        }
      } else {
        const accumulatedDataResponse = CoverageDetailedSummary(
          coverageSummary[0].MemberCoverage,
          accumulatorSummary,
        );
        const accumulatedData = [];
        accumulatedDataResponse.map((data) => {
          if (
            data?.Product === 'Medical' ||
            data?.Product === 'Dental' ||
            data?.Product === 'Prescription' ||
            data?.Product === 'Vision' ||
            data?.Product === 'ShortTermDisability' ||
            data?.Product === 'LongTermDisability'
          ) {
            accumulatedData.push(data);
          }
        });
        setMemberAccumulatedData(accumulatedData);
        setServerError(false);
        setIsNotFound(false);
        setIsAPIFailed(false);
        setSkeletonLoader(false);
      }
    },
    [loggedInMemberType, loggedInUserOID],
  );

  useEffect(() => {
    if (memberSummaryStatus === 'FULFILLED') {
      const List = getFamilyList(
        employeeInfo,
        dependentsInfo,
        loggedInMemberType,
        loggedInUserOID,
      );
      setOptions(List);
      if (employeeInfo.Family) {
        setSelectedOption(List[0]);
      } else {
        const userIndex =
          List &&
          List.map((x) => {
            return x.oid;
          }).indexOf(loggedInUserOID);
        setSelectedOption(List[userIndex]);
        setActiveMemberIndex(userIndex);
      }
      fetchCoveragAccumulator(loggedInMemberType, loggedInUserOID);
    } else if (memberSummaryStatus === 'REJECTED') {
      setServerError(true);
    }
  }, [
    dependentsInfo,
    dispatch,
    employeeInfo,
    fetchCoveragAccumulator,
    memberSummaryStatus,
  ]);

  const onChangeHandler = (e) => {
    setSelectedOption(e);
    setSkeletonLoader(true);
    if (e.value === 'Family') {
      setActiveMember('Family');
      setActiveMemberIndex(0);
      fetchCoveragAccumulator(loggedInMemberType, loggedInUserOID);
    } else {
      setActiveMember('Individual');
      const [IndividualType, IndividualOID] = e.value.split(',');
      setActiveMemberIndex(getActiveMemberIndex(options, e));
      fetchCoveragAccumulator(IndividualType, IndividualOID);
    }
  };

  return {
    onChangeHandler,
    options,
    selectedValue: selectedOption,
    memberAccumulatedData,
    defaultNetworkForAll,
    activeMember,
    activeMemberIndex,
    skeletonLoader,
    serverError,
    isNotFound,
    isAPIFailed,
  };
};
